import { ImageUrlOptions } from './types'

/**
 * Builds a complete image URL from a hash using the static asset API
 */
export function buildImageUrl(
  staticAssetApiUrl: string,
  hash: string | undefined | null,
  options: ImageUrlOptions = {}
): string | null {
  // Return null for invalid hashes
  if (!hash || hash.trim() === '') {
    return null
  }

  if (!staticAssetApiUrl || staticAssetApiUrl.trim() === '') {
    console.warn('Static asset API URL not available')
    return null
  }

  // Normalize base URL (remove trailing slash to prevent double slash)
  let baseUrl = staticAssetApiUrl
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1)
  }

  const imagePath = `/assets/images/${hash.replace('images/', '')}`

  // Build query parameters using imaginary library format
  const queryParams = new URLSearchParams()

  // Always add the resize operation (corrected parameter name)
  queryParams.set('operation', 'resize')

  if (options.height) queryParams.set('height', options.height.toString())
  if (options.format) queryParams.set('format', options.format)
  if (options.quality) queryParams.set('quality', options.quality.toString())
  if (options.width) queryParams.set('width', options.width.toString())

  const queryString = queryParams.toString()
  return baseUrl + imagePath + (queryString ? `?${queryString}` : '')
}
